import React from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { ForgotPassword, LoginProxy, getAuthServer } from '../../utils/proxy/Authproxy';
import 'bootstrap/dist/css/bootstrap.min.css'
import { Button, Container, Image, InputGroup } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';




function Login2(props) {
  const [companyid, setCompanyid] = useState();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(true);

  const getLogin = async (email, password) => {

    let login = await LoginProxy(email, password);

    if (login) {
      if (login.message) {
        Swal.fire({
          title:'Info',
          text:login.message,
          icon:'info'
        })
      }else{

      props.setIsloggedin();
      localStorage.setItem("accessToken", login.accessToken);
      localStorage.setItem("tokenType", login.tokenType);
      localStorage.setItem("username", login.username);
      localStorage.setItem("firstname", login.firstname);
      localStorage.setItem("lastname", login.lastname);
      localStorage.setItem("role", login.role);
      localStorage.setItem("uuid", login.uuid);
      localStorage.setItem("type", login.type);
      localStorage.setItem("adminid", login.adminid);
      localStorage.setItem("managers", login.managerid);
      localStorage.setItem("image", login.image);
    }

    } else {
      Swal.fire({
        title: "Invalid Login credentials..!",
        text: "Check The Login Details You Have Entered.",
        icon: "error"
      });
    }
  }

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (username === '' || password === '' || companyid === '') {
      alert('All Fields Are required');
    } else {
     
        let srvd;
        let attempts = 0;
        const maxRetries = 3;

        while (attempts < maxRetries) {
            try {
                srvd = await getAuthServer(companyid);

                // Check for a valid response
                if (srvd && srvd !== 'InternalServerError') {
                    break; // Success, exit the loop
                } else {
                    throw new Error('InternalServerError');
                }
            } catch (err) {
                attempts++;
                console.warn(`Attempt ${attempts} failed: ${err.message}`);

                if (attempts >= maxRetries) {
                    console.error(`Failed after ${attempts} attempts`);
                    throw err; 
                }
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }    

      if (srvd) {
        localStorage.setItem("AUTH_URL", srvd.authurl)
        localStorage.setItem("REPORTING_URL", srvd.reportingurl)
        getLogin(username, password, props);
      } else {
        Swal.fire({
          title: "Invalid !",
          text: "Invalid Company Id",
          icon: "error"
        });
      }


    }




  };

  const handleForgotPassword = async () => {
    if ((companyid == '' || companyid == null) || (username == '' || username == null)) {
      Swal.fire({
        title: 'Info',
        text: 'Enter Company Id And Username then Click on Forget Password Link',
        icon: 'info'
      })
    } else {
        let d;
        let attempts = 0;
        const maxRetries = 3;

        while (attempts < maxRetries) {
            try {
                d = await getAuthServer(companyid);

                // Check for a valid response
                if (d && d !== 'InternalServerError') {
                    break; // Success, exit the loop
                } else {
                    throw new Error('InternalServerError');
                }
            } catch (err) {
                attempts++;
                console.warn(`Attempt ${attempts} failed: ${err.message}`);

                if (attempts >= maxRetries) {
                    console.error(`Failed after ${attempts} attempts`);
                    throw err; 
                }
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }        
      if (d.id) {
        Swal.showLoading();
        let k = await ForgotPassword(d.authurl, username);
        if (k.status === 'success') {
          Swal.hideLoading();
          Swal.fire({
            title: 'Success',
            text: k.message,
            icon: 'success'
          })
          setCompanyid(null);
          setUsername('');
        } else if (k.status === 'error') {
          Swal.hideLoading();
          Swal.fire({
            title: 'Error',
            text: k.message,
            icon: 'error'
          })
        } else {
          Swal.hideLoading();
          Swal.fire({
            title: 'Error',
            text: 'Something Went Wrong',
            icon: 'error'
          })
        }
      } else {
        Swal.hideLoading();
        Swal.fire({
          title: 'Error',
          text: 'Invalid Company Id',
          icon: 'error'
        })
      }
    }
  }

  function handleShowPassword() {
    setShowPassword(!showPassword)
  }


  return (
    <>
      {/* <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/images/bg.png'})`, backgroundPoistion: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover", height: "100vh", alignItems: "center", display: "flex", justifyContent: "center", position: "relative" }}>
        <div style={{ backgroundColor: "white", position: "absolute", borderRadius: "20px" }}>
          <form onSubmit={(e) => handleSubmit(e)}>
            <Container style={{ height: "90vh" }}>
              <Row style={{ height: "100%" }}>
                <Col md={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                  <div style={{ padding: "20px 60px" }}>
                    
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <img src={process.env.PUBLIC_URL + '/images/nav3.png'} style={{ width: "50%" }} alt='team insights'></img>
                    </div>

                 
                      <h3 style={{ display: "flex", marginTop: "20px", fontFamily: "helvetica" }}>Login</h3>
                      <div >
                        <Form.Group>

                          <Form.Label htmlFor="inputPassword5">Company Id</Form.Label>
                          <Form.Control
                            type="number"

                            style={{ backgroundColor: "white" }}
                            placeholder='Enter your Company Id'
                            value={companyid}
                            onChange={(e) => setCompanyid(e.target.value)}
                          />
                        </Form.Group>
                      </div>

                      <div >



                        <Form.Group>

                          <Form.Label htmlFor="inputPassword5">Username</Form.Label>
                          <Form.Control
                            type="text"

                            style={{ backgroundColor: "white" }}
                            placeholder='Enter your username'
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </Form.Group>
                      </div>


                      <div  >

                        <Form.Group>

                          <Form.Label htmlFor="inputPassword5">Password</Form.Label>


                          <InputGroup className="mb-3">
                            <Form.Control
                              placeholder='Enter your password'
                              type={showPassword ? "password" : "text"}
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              style={{ backgroundColor: "white" }}
                            />
                            <Button variant="outline-secondary" id="button-addon2" onClick={() => handleShowPassword()}>
                              {showPassword ? <FaEyeSlash />
                                : <FaEye />}

                            </Button>
                          </InputGroup>
                        </Form.Group>

                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <button className='btn' style={{ color: "white", border: "none", fontSize: "20px", padding: "20px", borderRadius: "30px", backgroundColor: "#2AB9D4", display: "flex", marginTop: "20px", height: "40px", width: "180px", alignItems: "center", justifyContent: "center" }} type="submit" >Login</button>

                        <p style={{ color: "#7D7D7D", paddingTop: "20px" }}><span onClick={handleForgotPassword} >Forgot password?</span></p>
                      </div>
                  
                  </div>



                </Col>

                <Col md={6} style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/images/team.jpg'})`, backgroundRepeat: 'no-repeat', backgroundSize: "cover", borderTopRightRadius: "20px", borderBottomRightRadius: "20px" }} className='d-none d-md-block'>
                </Col>
              </Row>
            </Container>

          </form>
        </div>
      </div> */}
          <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center" style={{
      position: 'relative',
      overflow: 'hidden',
      padding: '1rem',
    }}>

      {/* Top-left blob */}
      <svg
        viewBox="0 0 200 200"
        style={{
          position: 'absolute',
          top: '-180px',
          left: '-180px',
          width: '600px',
          height: '600px',
          zIndex: 0,
          animation: 'float1 6s ease-in-out infinite',
        }}
      >
        <g transform="translate(100 100)">
          <path
            fill="rgb(70, 63, 111)"
            d="M71.4,-22.6C80.6,4.9,67.6,40.1,43.1,57.5C18.5,75,-17.7,74.6,-41.4,57.3C-65,40.1,-76,5.9,-67.1,-21.4C-58.1,-48.7,-29,-69,1.1,-69.4C31.2,-69.7,62.3,-50,71.4,-22.6Z"
          ></path>
        </g>
      </svg>

      {/* Bottom-right blob */}
      <svg
        viewBox="0 0 200 200"
        style={{
          position: 'absolute',
          bottom: '-180px',
          right: '-180px',
          width: '600px',
          height: '600px',
          zIndex: 0,
          animation: 'float1 6s ease-in-out infinite',
        }}
      >
        <g transform="translate(100 100)">
          <path
            fill="rgb(70, 63, 111)"
            d="M71.4,-22.6C80.6,4.9,67.6,40.1,43.1,57.5C18.5,75,-17.7,74.6,-41.4,57.3C-65,40.1,-76,5.9,-67.1,-21.4C-58.1,-48.7,-29,-69,1.1,-69.4C31.2,-69.7,62.3,-50,71.4,-22.6Z"
          ></path>
        </g>
      </svg>

      <div className="row w-100 justify-content-center g-0">
        {/* Login Form Section */}
        <div className="col-12 col-md-6 col-lg-5 d-flex justify-content-center g-0" style={{ zIndex: 1 }}>
          <div className="card shadow-sm w-100" style={{ padding: "30px", borderRadius: "12px", maxWidth: "500px" }}>
            <div className="d-flex align-items-center justify-content-center mb-4">
              <img src={process.env.PUBLIC_URL + '/images/nav3.png'} style={{ width: "50%" }} alt='team insights'></img>
            </div>
            <h4 className="mb-4 text-start">Log In</h4>

            <form onSubmit={(e) => handleSubmit(e)}>
             <div>
              <Form.Group>
                <Form.Label htmlFor="companyId">Company ID</Form.Label>
                <Form.Control
                  type="number"
                  id="companyId"
                  placeholder="Enter your Company ID"
                  style={{ backgroundColor: "white" }}
                  value={companyid}
                  onChange={(e) => setCompanyid(e.target.value)}
                />
              </Form.Group>
            </div>
                          <div>
              <Form.Group>
                <Form.Label htmlFor="username">Username</Form.Label>
                <Form.Control
                  type="text"
                  id="username"
                  placeholder="Enter your username"
                  style={{ backgroundColor: "white" }}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Group>
            </div>

                          <div>
              <Form.Group>
                <Form.Label htmlFor="password">Password</Form.Label>

                <InputGroup className="mb-3">
                  <Form.Control
                    id="password"
                    placeholder="Enter your password"
                    type={showPassword ? "password" : "text"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ backgroundColor: "white" }}
                  />
                  <Button
                    variant="outline-secondary"
                    id="button-addon2"
                    onClick={handleShowPassword}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </Button>
                </InputGroup>
              </Form.Group>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <button
                className="btn"
                style={{
                  color: "white",
                  border: "none",
                  fontSize: "20px",
                  padding: "20px",
                  borderRadius: "30px",
                  backgroundColor: "rgb(70, 63, 111)",
                  display: "flex",
                  marginTop: "20px",
                  height: "40px",
                  width: "180px",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                type="submit"
              >
                Login
              </button>

              <p style={{ color: "#7D7D7D", paddingTop: "20px" }}>
                <span onClick={handleForgotPassword} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                  Forgot password?
                </span>
              </p>
            </div>
            </form>
          </div>
        </div>

        {/* Welcome Panel Section */}
        <div className="col-12 col-md-6 d-none d-md-block g-0">
          <div className="card" style={{
            height: '550px',
            width: '100%',
            backgroundColor: 'rgb(70, 63, 111)',
            overflow: 'hidden',
            color: '#fff',
          }}>
            <div style={{
              zIndex: 1,
              position: 'absolute',
              top: '200px',
              left: '40px',
              color: '#fff',
              width: '400px',
            }}>
              <h2>Welcome To Team Insights</h2>
              <p>Leadership means managing people, processes, and progress.</p>
            </div>

                     <svg
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: 'absolute',
              top: '-80px',
              left: '-80px',
              width: '250px',
              height: '250px',
              zIndex: 0,
              opacity: 0.7,
              animation: 'float1 6s ease-in-out infinite',
              transformOrigin: 'center',
            }}
          >
            <defs>
              <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="rgb(70, 63, 111)" />
                <stop offset="100%" stopColor="rgb(132, 113, 159)" />
              </linearGradient>
            </defs>
            <g transform="translate(100 100)">
              <path
                fill="url(#gradient1)"
                d="M59.6,-31.6C71.8,-13.2,72.5,14.5,60.7,35.6C48.9,56.7,24.4,71,-1,71.6C-26.5,72.2,-53,59.1,-62,39.7C-70.9,20.3,-62.3,-5.299999999999999,-49,-24.3C-35.8,-43.3,-17.9,-55.7,2.9000000000000004,-57.3C23.7,-59,47.3,-50,59.6,-31.6Z"
              />
            </g>
          </svg>

          <svg
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: 'absolute',
              top: '-120px',
              right: '-70px',
              width: '350px',
              height: '350px',
              zIndex: 0,
              opacity: 0.7,
              animation: 'float2 8s ease-in-out infinite',
              transformOrigin: 'center',
            }}
          >
            <defs>
              <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
               <stop offset="0%" stopColor="rgb(70, 63, 111)" />
                <stop offset="100%" stopColor="rgb(132, 113, 159)" />
              </linearGradient>

            </defs>
            <g transform="translate(100 100)">
              <path
                fill="url(#gradient2)"
                d="M39.5,-52C52.8,-52.9,66.3,-44.7,76,-32.2C85.6,-19.7,91.3,-2.9,83.6,8.1C75.9,19,54.7,24,42,33.6C29.3,43.2,25.1,57.3,16.5,63.1C7.8,68.8,-5.4,66.1,-18.3,62.4C-31.3,58.6,-43.9,53.8,-47.8,44.2C-51.7,34.7,-46.9,20.4,-49.9,6.5C-52.8,-7.3,-63.6,-20.6,-61.3,-29.1C-59.1,-37.6,-44,-41.2,-31.6,-40.7C-19.2,-40.2,-9.6,-35.6,1.7,-38.3C13.1,-41,26.2,-51,39.5,-52Z"
              />
            </g>
          </svg>

          <svg
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: 'absolute',
              bottom: '-350px',
              right: '-60px',
              width: '650px',
              height: '650px',
              zIndex: 0,
              opacity: 0.7,
              animation: 'float3 7s ease-in-out infinite',
              transformOrigin: 'center',
            }}
          >
            <defs>
              <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
             <stop offset="0%" stopColor="rgb(70, 63, 111)" />
                <stop offset="100%" stopColor="rgb(132, 113, 159)" />
              </linearGradient>
            </defs>
            <g transform="translate(100 100)">
              <path
                fill="url(#gradient3)"
                d="M44.5,-68.9C59.6,-59.5,75.3,-50.5,81.1,-37.2C86.9,-23.9,82.9,-6.3,74.4,6.3C65.8,19,52.6,26.6,43.2,37.3C33.7,48.1,28,62.1,19.1,64.5C10.1,67,-2.1,57.9,-18.1,55.9C-34.2,53.9,-54,58.9,-63.3,52.5C-72.6,46,-71.3,28.1,-71.7,11.6C-72.2,-4.9,-74.4,-19.9,-68.6,-30.8C-62.9,-41.7,-49.2,-48.5,-36.5,-59.1C-23.7,-69.6,-11.9,-83.8,1.4,-86C14.7,-88.1,29.4,-78.3,44.5,-68.9Z"
              />
            </g>
          </svg>
          </div>
        </div>
      </div>

      {/* Responsive Floating Animations */}
      <style>{`
        @keyframes float1 {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes float2 {
          0%, 100% { transform: translateY(0px) translateX(0); }
          50% { transform: translateY(-15px) translateX(10px); }
        }
        @keyframes float3 {
          0%, 100% { transform: translateY(0px) translateX(0); }
          50% { transform: translateY(-25px) translateX(-10px); }
        }

       @media (max-width: 768px) {
        h2 {
          font-size: 1.5rem;
        }
        p {
          font-size: 0.9rem;
        }
      }
            `}</style>
    </div>
    </>
  )
}

export default Login2;